// Enhanced Mock data for Ubee Bakery Landing Page

export const bakeryInfo = {
  name: "Ubee Bakery",
  motto: "Kelembutan ada pada genggaman",
  description: "Kami menghadirkan kelezatan dan kelembutan dalam setiap gigitan. Dengan bahan-bahan pilihan dan resep tradisional yang telah teruji, Ubee Bakery menjadi tempat terbaik untuk menemukan roti, kue, dan pastry yang memanjakan lidah Anda.",
  hero: {
    title: "Ubee Bakery",
    subtitle: "Kelembutan ada pada genggaman",
    description: "Rasakan kelezatan roti segar dan pastry terbaik yang dibuat dengan cinta setiap hari",
    backgroundImage: "https://images.unsplash.com/photo-1657498023828-1e0181449d9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxiYWtlcnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg1MjE0MTN8MA&ixlib=rb-4.1.0&q=85"
  },
  contact: {
    address: "Jl. Raya Pakuniran No. 363 Desa sukodadi - Paiton",
    phone: "+62 851 3438 2238",
    whatsapp: "+6285134382238",
    email: "hello@ubeebakery.com",
    hours: {
      weekdays: "07:00 - 21:00",
      weekend: "07:00 - 21:00"
    },
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3953.6821014979146!2d113.50892420000001!3d-7.717217799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd703f8ba2a6863%3A0x84ad3648f466e7d2!2sUbee%20Bakery%20paiton!5e0!3m2!1sid!2sid!4v1758538354710!5m2!1sid!2sid"
  },
  social: {
    instagram: "https://instagram.com/ubeebakery",
    tiktok: "https://tiktok.com/@ubeebakery", 
    facebook: "https://facebook.com/ubeebakery"
  }
};

export const products = [
  {
    id: 1,
    name: "Long Brownies",
    description: "Brownies cokelat lembut dengan topping choco chips melimpah, dihiasi almond slice dan dekorasi manis bertuliskan ucapan spesial.",
    price: "Rp 35.000",
    image: "/assets/images/qop64hqop64hqop6.png",
    category: "Brownies"
  },
  {
    id: 2,
    name: "Drizzle Delight",
    description: "Kue tart cantik dengan lapisan krim putih lembut, dihiasi lelehan cokelat yang menetes elegan di sisi kue dan taburan serutan cokelat melimpah di atasnya.",
    price: "Rp 60.000",
    image: "/assets/images/dhhxc9dhhxc9dhhx.png",
    category: "Cake"
  },
  {
    id: 3,
    name: "Crumble Bun",
    description: "Roti lembut dengan lapisan crumble cokelat manis di bagian luar dan sentuhan garis krim putih sebagai hiasan. Tekstur empuk di dalam berpadu dengan gurih dan manis di luar.",
    price: "Rp 20.000",
    image: "/assets/images/dh8jqidh8jqidh8j.png",
    category: "Breads"
  },
  {
    id: 4,
    name: "Red Velvet Soft Bun",
    description: "Roti lembut berbalut taburan red velvet crumbs yang manis dan cantik. Teksturnya empuk dengan sentuhan rasa khas red velvet.",
    price: "Rp 25.000",
    image: "/assets/images/65o4qb65o4qb65o4.png",
    category: "Breads"
  },
  {
    id: 5,
    name: "Strawberry Love Cup",
    description: "Dessert manis dalam cup berisi lapisan krim lembut dengan sentuhan saus stroberi dan topping hati pink yang cantik.",
    price: "Rp 15.000",
    image: "/assets/images/1a6ubf1a6ubf1a6u.png",
    category: "Dessert"
  },
  {
    id: 6,
    name: "Birthday Cake Kuromi",
    description: "Kue lezat ini dilapisi dengan krim mentega berwarna ungu ceria dan dihiasi dengan detail drip putih yang elegan, serta aneka topper karakter Kuromi dan My Melody.",
    price: "Rp 100.000",
    image: "/assets/images/tmb36ytmb36ytmb3.png",
    category: "Cake"
  },
  {
    id: 7,
    name: "Tiramisu Oreo Cupcake",
    description: "Kue yang memadukan lapisan biskuit lembut dengan krim vanila yang kaya rasa, juga keseimbangan sempurna dari krim dan renyahnya taburan biskuit Oreo",
    price: "Rp 15.000",
    image: "/assets/images/2991a82991a82991.png",
    category: "Dessert"
  },
  {
    id: 8,
    name: "Sweet Blossom Bento Cake",
    description: "Red velvet cupcake dengan cream cheese frosting yang istimewa",
    price: "Rp 22.000",
    image: "/assets/images/j36hjnj36hjnj36h.png",
    category: "Cake"
  }
];

export const categories = [
  { id: 'all', name: 'Semua', count: products.length },
  { id: 'Breads', name: 'Breads', count: products.filter(p => p.category === 'Breads').length },
  { id: 'Dessert', name: 'Dessert', count: products.filter(p => p.category === 'Dessert').length },
  { id: 'Brownies', name: 'Brownies', count: products.filter(p => p.category === 'Brownies').length },
  { id: 'Cake', name: 'Cake', count: products.filter(p => p.category === 'Cake').length }
];

export const aboutContent = {
  title: "Tentang Kami",
  subtitle: "Passion for Perfect Baking",
  story: "Sejak tahun 2015, Ubee Bakery telah menjadi bagian dari kehidupan sehari-hari masyarakat. Kami memulai perjalanan dengan visi sederhana: menghadirkan kelezatan roti dan kue berkualitas tinggi yang dibuat dengan cinta dan dedikasi.",
  mission: "Setiap produk kami dibuat dari bahan-bahan pilihan dengan standar kualitas tertinggi. Tim baker berpengalaman kami bekerja setiap hari untuk memastikan bahwa setiap gigitan memberikan kepuasan dan kebahagiaan bagi pelanggan.",
  teamImage: "https://images.unsplash.com/photo-1578366941741-9e517759c620",
  workImage: "https://images.unsplash.com/photo-1532444482250-cb75e6bbd1fb",
  interiorImage: "/assets/images/fp3tpufp3tpufp3t.png",
  values: [
    {
      title: "Kualitas Terbaik",
      description: "Menggunakan bahan premium dan proses pembuatan yang teliti"
    },
    {
      title: "Resep Tradisional",
      description: "Mempertahankan cita rasa autentik dengan sentuhan modern"
    },
    {
      title: "Pelayanan Ramah",
      description: "Memberikan pengalaman berbelanja yang menyenangkan"
    }
  ],
  timeline: [
    {
      year: "2015",
      title: "Awal Mula",
      description: "Ubee Bakery didirikan dengan visi menghadirkan roti berkualitas tinggi"
    },
    {
      year: "2018",
      title: "Ekspansi Produk",
      description: "Menambah variasi pastry dan kue untuk memenuhi kebutuhan pelanggan"
    },
    {
      year: "2021",
      title: "Renovasi Toko",
      description: "Memperbarui interior dengan konsep modern yang tetap hangat dan nyaman"
    },
    {
      year: "2024",
      title: "Era Digital",
      description: "Meluncurkan platform online untuk mempermudah pemesanan pelanggan"
    }
  ]
};